import brandColor from './Brand';

const PAGE_ACCENT = '#0ab784';
const PAGE_BG_CANVAS = '#eef5f2';

/** Shared layout / typography tokens for authenticated app pages */
const pageTokens = {
	/** Brand accent — source colour for page background fade */
	bg: PAGE_ACCENT,
	/** Neutral end colour for the page gradient */
	bgCanvas: PAGE_BG_CANVAS,
	/** Subtle top-to-bottom fade based on `bg` */
	pageBackgroundGradient: `#f9f9f9`,
	/** Faded circle accent opacity (leads stat-card style) */
	decorCircleOpacity: 0.12,
	cardBg: '#ffffff',
	cardBorder: 'gray.200',
	cardRadius: 'xl',
	cardShadow: 'sm',
	sectionSpacing: 6,
	contentMaxW: '100%',
	headingColor: 'gray.800',
	mutedColor: 'gray.600',
	accentColorScheme: 'green',
	primaryButtonColorScheme: 'purple',
	secondaryButtonColorScheme: 'orange',
	buttonSize: 'sm',
	buttonRadius: 'lg',
	pageHeadingSize: 'md',
	sectionHeadingSize: 'sm',
	brand: brandColor,
};

export default pageTokens;
